<template>
    <div class="info-item" id="project__list__coordinator" @click="showChangeProjectLead">
        <div class="info-bubbles exclude-outside-click">
            <span
                class="initials badge badge-primary cursor-pointer exclude-outside-click"
                v-b-tooltip.hover.html
                :title="project.project_lead.name"
                v-if="project.project_lead"
            >
                <span class="exclude-outside-click">{{project.project_lead.name | textInitials}}</span>
            </span>
            <plus-button 
                v-show="!addProjectLeadFlag" 
                v-b-tooltip.hover.html
                :title="(project.project_lead ? `Change `: `Add `) + `${getSystemSetting('project__project_lead_label')}`"
                :style=" project.project_lead ? '' : 'margin-left: 22px;' "
                class="tagged-contacts plus-button plus-button--small"
            ></plus-button>
        </div>
        <div class="add-multiselect-group" v-show="addProjectLeadFlag">
            <div class="custom-field user-field custom-multiselect">
                <multiselect
                ref="projectLead"
                v-click-outside="outside"
                v-model="project.project_lead"
                :options="allActiveUsers"
                :option-height="42"
                :show-labels="false"
                :multiple="false"
                :allow-empty="false"
                label="name"
                track-by="id"
                v-show="addProjectLeadFlag"
                @close="addProjectLeadFlag=false"
                @input="projectLeadChanged();"
                ></multiselect>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    props:["project"],
    data() {
        return {
            addProjectLeadFlag: false,
        };
    },
    computed: {
        ...mapGetters([
            "allUsers",
            "userAbilities",
            "allActiveUsers",
            "systemSettings",
            "getSystemSetting",
        ]),

        userCanEditProject() {
			const userId = localStorage.getItem("userId");
            const project = this.project;

			if (this.userAbilities.accessAllProjects) {
				return this.userAbilities.editProject;
			}
			
			let isManager = false;
			if (project.engagement_manager instanceof Object) {
				isManager = userId == project.engagement_manager.id;
			} else {
				isManager = userId == project.engagement_manager;
			}

			return (this.userAbilities.editProject && isManager);
		},
    },
    methods: {
        ...mapActions(["changeProjectLead"]),

        projectLeadChanged() {
            this.changeProjectLead({project_lead: this.project.project_lead, id: this.project.id})
        },
        outside() {
            this.$set(this, "addProjectLeadFlag", false);
        },
        showChangeProjectLead() {
            if(!this.userCanEditProject) return;
            this.addProjectLeadFlag = true;
            this.$nextTick(() => {
                this.$refs.projectLead.$el.focus();
            });
        }
    },
}

</script>